export var SPARK_PRODUCT_NAME = 'MedEd Workspace';
export var SPARK_ROUTE_PREFIX = '/MedEd';
export var SPARK_PATHS = {
    root: SPARK_ROUTE_PREFIX,
    summary: "".concat(SPARK_ROUTE_PREFIX, "/summary"),
    students: "".concat(SPARK_ROUTE_PREFIX, "/students"),
    topics: "".concat(SPARK_ROUTE_PREFIX, "/topics"),
    assignments: "".concat(SPARK_ROUTE_PREFIX, "/assignments"),
    studentReport: "".concat(SPARK_ROUTE_PREFIX, "/students/:studentId")
};
export var SPARK_SUMMARY_PATHS = [SPARK_PATHS.root, SPARK_PATHS.summary];
export var SPARK_STUDENT_REPORT_TABS = {
    assignments: { hash: '#assignments', index: 0 },
    topics: { hash: '#topics', index: 1 }
};
export var SPARK_TAB_NAMES = {
    SUMMARY: 'Summary',
    STUDENTS: 'Students',
    TOPICS: 'Topics',
    ASSIGNMENTS: 'Assignments'
};
export var SPARK_TABS = [
    { id: 'spark-tab-summary', label: SPARK_TAB_NAMES.SUMMARY, paths: SPARK_SUMMARY_PATHS },
    { id: 'spark-tab-students', label: SPARK_TAB_NAMES.STUDENTS, paths: [SPARK_PATHS.students] },
    { id: 'spark-tab-topics', label: SPARK_TAB_NAMES.TOPICS, paths: [SPARK_PATHS.topics] },
    { id: 'spark-tab-assignments', label: SPARK_TAB_NAMES.ASSIGNMENTS, paths: [SPARK_PATHS.assignments] }
];
export var SPARK_NO_STUDENTS_FOUND_MESSAGE = 'No students found';
export var NO_TOPIC_DATA_MESSAGE = 'No topic data available';
export var SPARK_ASSIGNMENT_CONTENT_TYPES = {
    MCQ: 'MCQ',
    QUIZ: 'Quiz'
};
export var SPARK_ASSIGNMENT_PERIOD_OPTIONS = [
    { key: 'THIS_WEEK', name: 'This Week' },
    { key: 'NEXT_2_WEEKS', name: 'Next 2 Weeks' }
];
export var SPARK_DISTRIBUTION_OF_SCORES_RANGES = {
    FROM_0_TO_54: { label: '≤54%' },
    FROM_55_TO_64: { label: '55-64%' },
    FROM_65_TO_74: { label: '65-74%' },
    FROM_75_TO_84: { label: '75-84%' },
    FROM_85_TO_100: { label: '≥85%' }
};
